// assets/vh-h.js — WP-P20 Startseite (Pilot): zusammengesetzt aus den Fragmenten der Teile A/B/C (Hauptmodell, 23.09.2026).
// Geladen aus sections/vh-h-hero.liquid NACH vh-v2.js und vh-c2.js. ES5, keine Timer-Schleifen, kein MutationObserver.

// ===== WP-P20b =====
// WP-P20b — Teil A (Fold, Sortiment, Bestseller)
// Kein eigenes JS nötig: das Stärke-Sheet im Hero (#vh-h-staerke) öffnet/schließt über die
// bestehende Sheet-Logik aus assets/vh-v2.js (data-sheet-open/data-sheet-close, bereits vor
// diesem Fragment geladen, Brief §2 Ladestelle). Der Hover-Lift auf Kacheln/Bestseller-Karten
// ist reines CSS (@media (hover:hover), WP-P20b-css.css). Reveal (data-vh-reveal an
// vh-h-kacheln/vh-h-bestseller) und Count-up sind Teil C (Brief §6.3) — dieses Fragment setzt
// dafür keine eigene Logik, um die IntersectionObserver-Instanziierung nicht zu duplizieren.
(function () { 'use strict'; })();

// ===== WP-P20c =====
// WP-P20c — Teil B: Video-Start/Pause-Knopf (vh-h-herkunft) + Count-up (vh-h-stimmen).
// ES5, ein IIFE, kein Framework, keine Timer-Schleifen. IntersectionObserver nur fuer die zwei
// einmaligen Effekte (Video-Autostart, Count-up) - keine Sticky-Logik, kein MutationObserver.
// Alles unter prefers-reduced-motion:reduce deaktiviert (Autostart Video, Count-up-Animation);
// die statischen Werte bleiben in beiden Faellen korrekt sichtbar (kein JS noetig fuer Korrektheit).
(function () {
  'use strict';
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var saveData = false;
  try { saveData = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}

  // ---------- Video (vh-h-herkunft): kein Pause-Knopf mehr (Inhaber 30.09.2026) — reiner Loop,
  // einmaliger Autostart beim Sichtbarwerden. ----------
  $$('.vh-h-video').forEach(function (video) {
    if (!reduceMotion && !saveData && 'IntersectionObserver' in window) {
      var started = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !started) {
            started = true;
            video.play().catch(function () {});
            io.unobserve(video);
          }
        });
      }, { threshold: 0.3 });
      io.observe(video);
    }
  });

  // ---------- Count-up (vh-h-stimmen): 0 -> Zielwert in 900 ms, einmalig beim Sichtbarwerden ----------
  if (!reduceMotion && 'IntersectionObserver' in window) {
    $$('[data-count-to]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-count-to'));
      if (isNaN(target)) return;
      var decimals = parseInt(el.getAttribute('data-count-decimals'), 10) || 0;
      var suffix = el.getAttribute('data-count-suffix') || '';
      var endText = el.textContent;
      var done = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !done) {
            done = true;
            io.unobserve(el);
            var duration = 900;
            var t0 = null;
            function frame(ts) {
              if (t0 === null) t0 = ts;
              var p = Math.min(1, (ts - t0) / duration);
              var val = target * p;
              var text;
              try {
                text = val.toLocaleString('de-DE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
              } catch (e) {
                text = val.toFixed(decimals);
              }
              el.textContent = (p < 1) ? (text + suffix) : endText;
              if (p < 1) window.requestAnimationFrame(frame);
            }
            window.requestAnimationFrame(frame);
          }
        });
      }, { threshold: 0.3 });
      io.observe(el);
    });
  }
})();

// ===== WP-P20d =====
// WP-P20d — Teil C (Startseite-Pilot test-startseite): JS-Gate für den Reveal-Effekt.
// Wird vom Hauptmodell hinter die Fragmente WP-P20b/WP-P20c in assets/vh-h.js eingefügt
// (Reihenfolge A → B → C). ES5, eine IIFE, keine Timer-Schleifen, kein MutationObserver.
// IntersectionObserver ausschließlich für den einmaligen Reveal-Effekt (nicht für Sticky-Logik,
// Brief §2 Fragment-Formate). Unter prefers-reduced-motion: reduce bleibt die Klasse html.vh-h-js
// zwar gesetzt (harmlos — die CSS-Regeln in WP-P20d-css.css sind selbst unter
// @media(prefers-reduced-motion:reduce) auf "immer sichtbar" zurückgesetzt), der Observer wird aber
// gar nicht erst gebraucht: alle [data-vh-reveal]-Sektionen sind ohnehin von Anfang an sichtbar.
(function () {
  'use strict';

  var html = document.documentElement;

  // Sofort setzen (Brief §6.3: "html.classList.add('vh-h-js') sofort") — vor DOMContentLoaded,
  // damit kein Flash-of-unstyled-content zwischen "Basis-CSS ohne Klasse" (alles sichtbar) und
  // "Klasse gesetzt, aber Observer noch nicht gestartet" entsteht: die Ausgangs-Opacity in
  // WP-P20d-css.css gilt ausschließlich unter html.vh-h-js, also erst ab genau diesem Moment.
  html.classList.add('vh-h-js');

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* matchMedia in seltenen alten Browsern nicht verfügbar — Default false, Reveal läuft */ }

  function revealNow(el) {
    el.classList.add('is-in');
  }

  function initReveal() {
    var targets = [].slice.call(document.querySelectorAll('[data-vh-reveal]'));
    if (!targets.length) { return; }

    // Ohne IntersectionObserver (sehr alte Browser) oder bei reduzierter Bewegung: sofort zeigen,
    // kein Beobachten nötig — CSS deckt prefers-reduced-motion zusätzlich selbst ab, das hier ist
    // die JS-Seite derselben Regel (kein Observer-Overhead, wenn er nichts bewirken darf).
    if (reduceMotion || typeof window.IntersectionObserver !== 'function') {
      targets.forEach(revealNow);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revealNow(entry.target);
          io.unobserve(entry.target); // einmalig — kein wiederholtes Ein-/Ausblenden beim Scrollen
        }
      });
    }, { threshold: 0.12 });

    targets.forEach(function (el) { io.observe(el); });

    // r2: Fallback per Scroll-Pruefung (rAF-gedrosselt, keine Timer) - der Observer feuert bei Spruengen
    // (Anker, scrollTo) nicht zuverlaessig (Falle 12 der Pilot-Kette). Sichtbar = Oberkante < 88 % Viewport.
    var pending = targets.slice(); var ticking = false;
    function check() {
      ticking = false; var vh = window.innerHeight || 0;
      pending = pending.filter(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.88 && r.bottom > 0) { revealNow(el); io.unobserve(el); return false; }
        return true;
      });
      if (!pending.length) { window.removeEventListener('scroll', onScroll); }
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();

